<template>
  <div class="wrap">
    <general-header roleType="general"></general-header>
    <router-view class="main"></router-view>
  </div>
</template>
<script>
import generalHeader from '@/views/header'
export default {
  components: {
    generalHeader
  },
  mounted() {
    this.queryAccountInfo()
  },
  methods: {
    // 获取用户信息
    queryAccountInfo() {
      this.$request.get("queryAccountInfo").then(res => {
        if (res.err === 0) {
          this.$store.commit('saveUserInfo', {
            username: res.dat.usr,
            avatar: res.dat.photo
          })
        }
      })
    }
  },
};
</script>
<style lang="less" scoped>
.wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  .main {
    flex: 1;
    display: flex;
    overflow: hidden;
    background: #f0f0f0;
  }
}
</style>

